module.exports = __webpack_public_path__ + "img/salesgearLogo.f5146088.png";